module.exports = __webpack_public_path__ + "static/media/aquecedor2.cfa74705.png";